// 2025 Translations
export const translations2025 = {
  en: {
    'event.title': 'Third Sustainable Finance Meeting',
    'event.callForPapers': 'Call for Papers',
    'event.subtitle': 'Theme: Impact Finance in Africa',
    'event.date': 'May 13, 2025',
    'event.location': 'ISCAE-Casablanca, Morocco',
    'event.theme': 'Impact Finance in Africa',
    'nav.home': 'Home',
    'nav.schedule': 'Schedule',
    'nav.speakers': 'Speakers',
    'nav.partners': 'Partners',
    'nav.edition2025': '2025 Edition',
    'nav.edition2026': '2026 Edition',
    'about.context': 'The African Finance Network (AFN) is a non-profit, non-governmental organization that aims to connect universities, researchers, and professionals around African development. The main mission of AFN is to foster forward-thinking reflection on the challenges and opportunities of African emergence.',
    'about.journal': 'In support of these efforts, AFN publishes the scientific journal African Finance for Development Review (AFDR) (available at https://africanfinance.network/revue/), specialized in sustainable finance themes.',
    'about.history': 'Since 2023, the "Sustainable Finance Meetings" have established a reference framework for discussing major issues related to sustainable finance in Africa. The first edition, held in Rabat, marked the official launch of the African Observatory for Sustainable Finance (AOSF) with the support of prestigious institutions and government representatives. The 2024 edition, organized in Sfax, focused on climate risks and brought together more than 40 international and African speakers.',
    'about.current': 'The third edition, scheduled for May 13, 2025, in Casablanca, will continue this momentum by exploring the challenges and opportunities related to impact finance in Africa, with a focus on practical case studies, scientific research, and institutional initiatives promoting sustainable economy.',
    'objectives.title': 'Conference Objectives',
    'objectives.list': [
      'Promote sustainable finance as a strategic lever for economic and environmental development in Africa',
      'Raise awareness among researchers, practitioners, and decision-makers about innovative ESG impact measurement methods',
      'Provide a platform for exchanges on regulations, incentives, and solutions adapted to African businesses and institutions',
      'Highlight emerging technologies and their role in the sustainable transformation of African economies'
    ],
    'topics.title': 'Topics of Interest',
    'topics.list': [
      'Sustainable finance and its methodologies',
      'ESG impact measurement in Africa',
      'ESG regulations and standards',
      'Financing ecological and energy transition',
      'Synergy between ecological and digital transition',
      'Compensation mechanisms (Polluter-Pays principle)',
      'Corporate Social Responsibility (CSR) practices and innovations',
      'Fintech, blockchain, and artificial intelligence for sustainable finance',
      'Sustainability risk management'
    ],
    'deadlines.title': 'Calendar',
    'deadlines.launch': 'Call launch',
    'deadlines.launch.date': 'February 3, 2025',
    'deadlines.close': 'Call closure',
    'deadlines.close.date': 'March 30, 2025',
    'deadlines.response': 'Response to submissions',
    'deadlines.response.date': 'April 10, 2025',
    'deadlines.conference': 'Conference date',
    'deadlines.conference.date': 'May 13, 2025',
    'submission.title': 'Submission Guidelines',
    'submission.criteria': 'Researchers wishing to submit a paper must respect the following criteria:',
    'submission.format': 'Proposals must be written in Word format (.doc, .docx) and be submitted exclusively online to the following email address: financedurable2025@groupeiscae.ma',
    'submission.length': 'The text must not exceed 3,000 characters, including:',
    'submission.requirements': [
      'A provisional title',
      'A proposal summary',
      'A brief bibliography',
      'Five keywords'
    ],
    'submission.info': 'The following information must be completed in the submission form:',
    'submission.author.info': [
      'Author names',
      'Academic or professional affiliations',
      'Contact details (email, laboratory, affiliated institution)'
    
    ],
    'fees.title': 'Registration Fees',
    'fees.info': 'Presentations are free of charge. However, participants are responsible for certain additional costs (lunch break, etc.).',
    'contact.info': 'For any questions or additional information, please contact: financedurable2025@groupeiscae.ma',
    'organizers.title': 'Organizers',
    'organizers.participation': 'With the participation of the International Observatory of Sustainable Finance',
  },
  fr: {
    'event.title': 'Troisièmes Rencontres de la Finance Durable',
    'event.callForPapers': 'Appel à Communications',
    'event.subtitle': 'Thème : Finance à Impact en Afrique',
    'event.date': '13 mai 2025',
    'event.location': 'ISCAE-Casablanca, Maroc',
    'event.theme': 'Finance à Impact en Afrique',
    'nav.home': 'Accueil',
    'nav.schedule': 'Programme',
    'nav.speakers': 'Intervenants',
    'nav.partners': 'Partenaires',
    'nav.edition2025': 'Édition 2025',
    'nav.edition2026': 'Édition 2026',
    'about.context': "L'African Finance Network (AFN) est une organisation non gouvernementale à but non lucratif qui vise à connecter les universités, les chercheurs et les professionnels autour du développement de l'Afrique. La mission principale de l'AFN est de favoriser une réflexion prospective sur les défis et opportunités de l'émergence africaine.",
    'about.journal': "En appui à ces efforts, l'AFN publie la revue scientifique African Finance for Development Review (AFDR) (à consulter sur https://africanfinance.network/revue/), spécialisée dans les thématiques de la finance durable.",
    'about.history': "Depuis 2023, les « Rencontres de la Finance Durable » ont établi un cadre de référence pour discuter des enjeux majeurs liés à la finance durable en Afrique. La première édition, tenue à Rabat, a marqué le lancement officiel de l'Observatoire Africain de la Finance Durable (OAFD) avec le soutien d'institutions prestigieuses et de représentants gouvernementaux. L'édition 2024, organisée à Sfax, a porté sur les risques climatiques et a rassemblé plus de 40 conférenciers internationaux et africains.",
    'about.current': "La troisième édition, prévue pour le 13 mai 2025 à Casablanca, poursuivra cet élan en explorant les enjeux et opportunités liés à la finance à impact en Afrique, avec un accent sur les études de cas pratiques, la recherche scientifique et les initiatives institutionnelles favorisant l'économie durable.",
    'objectives.title': 'Objectifs de la Conférence',
    'objectives.list': [
      'Promouvoir la finance durable comme un levier stratégique pour le développement économique et environnemental en Afrique',
      "Sensibiliser les chercheurs, praticiens et décideurs aux méthodes innovantes de mesure d'impact ESG (Environnement, Société, Gouvernance)",
      "Offrir une plateforme d'échanges sur les régulations, incitations et solutions adaptées aux besoins des entreprises et institutions africaines",
      'Mettre en avant les technologies émergentes et leur rôle dans la transformation durable des économies africaines'
    ],
    'topics.title': "Sujets d'Intérêt",
    'topics.list': [
      'Finance durable et ses méthodologies',
      "Mesure d'impact ESG en Afrique",
      'Réglementations et standards ESG',
      'Financement de la transition écologique et énergétique',
      'Synergie entre transition écologique et numérique',
      'Mécanismes de compensation (principe « Pollueur-Payeur »)',
      'Pratiques et innovations en Responsabilité Sociétale des Entreprises (RSE)',
      'Fintech, blockchain et intelligence artificielle pour une finance durable',
      'Gestion des risques liés à la durabilité'
    ],
    'deadlines.title': 'Calendrier',
    'deadlines.launch': "Lancement de l'appel",
    'deadlines.launch.date': '3 février 2025',
    'deadlines.close': "Clôture de l'appel",
    'deadlines.close.date': '30 mars 2025',
    'deadlines.response': 'Réponse aux soumissions',
    'deadlines.response.date': '10 avril 2025',
    'deadlines.conference': 'Date de la conférence',
    'deadlines.conference.date': '13 mai 2025',
    'submission.title': 'Directives de Soumission',
    'submission.criteria': 'Les chercheurs souhaitant soumettre une communication doivent respecter les critères suivants :',
    'submission.format': 'Les propositions doivent être rédigées en format Word (.doc, .docx) et soumises exclusivement en ligne à l\'adresse email suivante: financedurable2025@groupeiscae.ma',
    'submission.length': 'Le texte ne doit pas excéder 3 000 caractères, incluant :',
    'submission.requirements': [
      'Un titre provisoire',
      'Un résumé de la proposition',
      'Une bibliographie succincte',
      'Cinq mots-clés'
    ],
    'submission.info': 'Les informations suivantes doivent être complétées dans le formulaire de dépôt :',
    'submission.author.info': [
      'Noms des auteurs',
      'Affiliations universitaires ou professionnelles',
      'Coordonnées (adresse e-mail, laboratoire, institution de rattachement)'
      
   ],  
    'fees.title': "Frais d'Inscription",
    'fees.info': "La présentation des communications est gratuite. Toutefois, certains frais additionnels restent à la charge des participants (pause déjeuner, etc.)",
    'contact.info': 'Pour toute question ou information complémentaire, veuillez contacter : financedurable2025@groupeiscae.ma',
    'organizers.title': 'Organisateurs',
    'organizers.participation': "Avec la participation de l'Observatoire International de la Finance Durable",
  }
};

// 2026 Translations
export const translations2026 = {
  en: {
    'event.title': 'Fourth Sustainable Finance Meeting',
    'event.callForPapers': 'Call for Papers',
    'event.subtitle': 'Theme: Financing and Energy Transition in Africa: What Model for Mauritania?',
    'event.date': 'May 14, 2026',
    'event.location': 'ISCAE Nouakchott, Mauritania',
    'event.theme': 'Financing and Energy Transition in Africa',
    'event.patronage': 'Under the patronage of the Ministry of Higher Education and Scientific Research',
    'nav.home': 'Home',
    'nav.schedule': 'Schedule',
    'nav.speakers': 'Speakers',
    'nav.partners': 'Partners',
    'nav.edition2025': '2025 Edition',
    'nav.edition2026': '2026 Edition',
    'about.context': 'Facing climate emergencies and the strong demographic and economic dynamics of the continent, Africa stands at a strategic turning point. The energy transition represents an opportunity to promote sustainable growth, reduce dependence on fossil fuels, secure energy access, and attract international capital.',
    'about.mauritania': 'Mauritania, endowed with considerable renewable energy potential (solar, wind, green hydrogen), is emerging as a future regional energy player. However, the transition to a sustainable energy model requires innovative financing mechanisms, adapted governance, effective public-private partnerships, and strategic integration into African and international markets.',
    'objectives.title': 'Conference Objectives',
    'objectives.list': [
      'Stimulate academic and professional reflection on the financial conditions of energy transition in Africa and Mauritania',
      'Analyze appropriate economic and regulatory models',
      'Highlight structuring projects, innovations, and operational challenges',
      'Foster dialogue between researchers, public decision-makers, investors, and development actors'
    ],
    'topics.title': 'Thematic Axes',
    'axis1.title': 'Axis 1: Financing Energy Transition and Innovation in Africa',
    'axis1.topics': [
      'Public financing, green budget, sustainable taxation',
      'Sovereign funds, public development banks',
      'Role of international financial institutions',
      'Financing green and blue infrastructure',
      'Role of startups, FinTech and CleanTech',
      'Socially responsible Islamic finance',
      'Public-private partnerships (PPP) in the energy sector'
    ],
    'axis2.title': 'Axis 2: Metrics',
    'axis2.topics': [
      'Green bonds, sustainability-linked loans',
      'ESG standards and extra-financial reporting',
      'Social and environmental impacts of the transition'
    ],
    'axis3.title': 'Axis 3: Taxonomy',
    'axis3.topics': [
      'Development of solar, wind and green hydrogen',
      'National strategies and regulatory frameworks',
      'Role of major energy projects (e.g., green hydrogen, offshore gas)',
      'Equitable access to energy',
      'Vulnerable territories and rural populations',
      'Energy market regulation',
      'Alignment with international frameworks (SDGs, Paris Agreement, taxonomies)'
    ],
    'submission.title': 'Submission Guidelines',
    'submission.criteria': 'Authors are invited to submit:',
    'submission.requirements': [
      'A synthesis text of at least 1,000 words',
      '5 keywords',
      'Name(s), affiliation(s) and email(s)'
    ],
    'submission.format': 'All submissions must be in Word format (doc, docx). Proposals can be submitted in French, English, or Arabic',
    'submission.abstract': 'The abstract must clearly present:',
    'submission.abstract.requirements': [
      'The research problem',
      'The methodology',
      'The expected contribution',
      'Expected or achieved results'
    ],
    'deadlines.title': 'Provisional Calendar',
    'deadlines.submission': 'Deadline for abstract submission',
    'deadlines.submission.date': 'January 30, 2026',
    'deadlines.notification': 'Notification to authors',
    'deadlines.notification.date': 'February 15, 2026',
    'deadlines.final': 'Final version submission',
    'deadlines.final.date': 'March 15, 2026',
    'deadlines.decision': 'Final decision',
    'deadlines.decision.date': 'March 30, 2026',
    'deadlines.conference': 'Conference date',
    'deadlines.conference.date': 'May 14, 2026',
    'submission.email': 'Submission address: soumissions.fd2026@iscae.mr',
    'committee.title': 'Scientific Committee',
    'committee.members': 'Babacar SENE, Dhafer SAIDANE, Foued Badr GABSI, Karim KAMMOUN, Maher GASSAB, Mohamed Amine ISSAMI, Mohamed EMANY, Mohamed Lemine IDOUMOU, Mohamed Sidi KHALIFA, Mohamed Vall Ould EL ALEM, Nabil JEDLANE, Nouri CHTOUROU, Oussama GHAZI, Saad Bouh REGAD, Sana BEN ABDALLAH, Sidi Mohamed ABD DAYEM, Slah HELLARA, Taleb KHYAR, Amine LAHIANI.',
    'contact.title': 'Contact',
    'contact.info': 'For any additional information:',
    'contact.emails': 'sana.benabdallah@africanfinance.network | m.khaliffaa@iscae.mr',
    'organizers.title_1': 'Organized by',
    'organizers.title_2': 'With the kind support of',
    'organizers.participation': 'With the participation of the International Observatory of Sustainable Finance',
  },
  fr: {
    'event.title': 'Quatrièmes Rencontres de la Finance Durable',
    'event.callForPapers': 'Appel à Communications',
    'event.subtitle': 'Thème : Financement et transition énergétique en Afrique : quel modèle pour la Mauritanie ?',
    'event.date': '14 mai 2026',
    'event.location': 'ISCAE Nouakchott, Mauritanie',
    'event.theme': 'Financement et transition énergétique en Afrique',
    'event.patronage': 'Sous le patronage du Ministère de l\'Enseignement Supérieur et de la Recherche Scientifique',
    'nav.home': 'Accueil',
    'nav.schedule': 'Programme',
    'nav.speakers': 'Intervenants',
    'nav.partners': 'Partenaires',
    'nav.edition2025': 'Édition 2025',
    'nav.edition2026': 'Édition 2026',
    'about.context': 'Face aux urgences climatiques et aux fortes dynamiques démographiques et économiques du continent, l\'Afrique se trouve à un tournant stratégique. La transition énergétique représente une opportunité pour favoriser une croissance durable, réduire la dépendance aux énergies fossiles, sécuriser l\'accès à l\'énergie et attirer des capitaux internationaux.',
    'about.mauritania': 'La Mauritanie, dotée d\'un potentiel considérable en énergies renouvelables (solaire, éolien, hydrogène vert), s\'impose comme un futur acteur énergétique régional. Toutefois, la transition vers un modèle énergétique durable nécessite des mécanismes de financement innovants, une gouvernance adaptée, des partenariats public–privé efficaces et une intégration stratégique aux marchés africains et internationaux.',
    'objectives.title': 'Objectifs de la Conférence',
    'objectives.list': [
      'Stimuler la réflexion académique et professionnelle sur les conditions financières de la transition énergétique en Afrique et en Mauritanie',
      'Analyser les modèles économiques et réglementaires adaptés',
      'Mettre en lumière les projets structurants, innovations et défis opérationnels',
      'Favoriser le dialogue entre chercheurs, décideurs publics, investisseurs et acteurs du développement'
    ],
    'topics.title': 'Axes Thématiques',
    'axis1.title': 'Axe 1 : Financement de la transition énergétique et innovation en Afrique',
    'axis1.topics': [
      'Financement public, budget vert, fiscalité durable',
      'Fonds souverains, banques publiques de développement',
      'Rôle des institutions financières internationales',
      'Financement des infrastructures vertes et bleues',
      'Rôle des startups, FinTech et CleanTech',
      'Finance islamique socialement responsable',
      'Partenariats public–privé (PPP) dans le secteur énergétique'
    ],
    'axis2.title': 'Axe 2 : Métrique',
    'axis2.topics': [
      'Green bonds, sustainability-linked loans',
      'Normes ESG et reporting extra-financier',
      'Impacts sociaux et environnementaux de la transition'
    ],
    'axis3.title': 'Axe 3 : Taxonomie',
    'axis3.topics': [
      'Développement du solaire, de l\'éolien et de l\'hydrogène vert',
      'Stratégies nationales et cadres réglementaires',
      'Le rôle des grands projets énergétiques (ex : hydrogène vert, gaz offshore)',
      'Accès équitable à l\'énergie',
      'Territoires vulnérables et populations rurales',
      'Régulation du marché énergétique',
      'Alignement avec les cadres internationaux (ODD, Accord de Paris, taxonomies)'
    ],
    'submission.title': 'Directives de Soumission',
    'submission.criteria': 'Les auteurs sont invités à soumettre :',
    'submission.requirements': [
      'Un texte de synthèse d\'au moins 1 000 mots',
      '5 mots-clés',
      'Nom(s), affiliation(s) et courriel(s)'
    ],
    'submission.format': 'Toutes les soumissions doivent être en format Word (doc, docx). Les propositions peuvent être soumises en français, en anglais ou en arabe',
    'submission.abstract': 'Le résumé doit clairement présenter :',
    'submission.abstract.requirements': [
      'La problématique',
      'La méthodologie',
      'La contribution envisagée',
      'Les résultats attendus ou acquis'
    ],
    'deadlines.title': 'Calendrier Prévisionnel',
    'deadlines.submission': 'Date limite de soumission des résumés',
    'deadlines.submission.date': '30 janvier 2026',
    'deadlines.notification': 'Notification aux auteurs',
    'deadlines.notification.date': '15 février 2026',
    'deadlines.final': 'Envoi de la version finale',
    'deadlines.final.date': '15 mars 2026',
    'deadlines.decision': 'Décision finale',
    'deadlines.decision.date': '30 mars 2026',
    'deadlines.conference': 'Date du colloque',
    'deadlines.conference.date': '14 mai 2026',
    'submission.email': 'Adresse de soumission : soumissions.fd2026@iscae.mr',
    'committee.title': 'Comité Scientifique',
    'committee.members': 'Babacar SENE, Dhafer SAIDANE, Foued Badr GABSI, Karim KAMMOUN, Maher GASSAB, Mohamed Amine ISSAMI, Mohamed EMANY, Mohamed Lemine IDOUMOU, Mohamed Sidi KHALIFA, Mohamed Vall Ould EL ALEM, Nabil JEDLANE, Nouri CHTOUROU, Oussama GHAZI, Saad Bouh REGAD, Sana BEN ABDALLAH, Sidi Mohamed ABD DAYEM, Slah HELLARA, Taleb KHYAR, Amine LAHIANI.',
    'contact.title': 'Contact',
    'contact.info': 'Pour toute information complémentaire :',
    'contact.emails': 'sana.benabdallah@africanfinance.network | m.khaliffaa@iscae.mr',
    'organizers.title_1': 'Organisé par',
    'organizers.title_2': 'Avec l\'aimable soutien de',
    'organizers.participation': 'Avec la participation de l\'Observatoire International de la Finance Durable',
  }
};

// Default translations (for current edition - 2026)
export const translations = translations2026;

export type Language = 'en' | 'fr';
export type TranslationType = typeof translations2025.en;
